export const getCurrenciesData = ({ metaData: { currencies } }) => currencies;

export const getPricesData = ({ metaData: { prices } }) => prices;

export const getBanksData = ({ metaData: { banks } }) => banks;

export const getCancellationData = ({ metaData: { cancellation } }) => cancellation;
